import { isAgeVerificationMandatory, useApp, useUserInfo } from "@next-platform/client-common-core";

export const useAgeVerificationFlags = () => {
  const { isNsfwEnabled } = useApp();
  const { userProfile } = useUserInfo();
  const ageVerificationStatus = userProfile?.age_verification?.status;
  const isAgeVerificationEnabled = isNsfwEnabled;
  const isAgeVerificationRequired = isAgeVerificationEnabled && isAgeVerificationMandatory(ageVerificationStatus);

  return {
    isAgeVerificationEnabled,
    isAgeVerificationRequired,
  };
};
